import React, { useContext } from "react";
import Select from "react-select";
import { WindmillContext } from "@windmill/react-ui";
import { reactSelectCommonProps } from "utils/reactSelectTheme";

const SelectDepartment = ({
  setSelecttedDepartment,
  register,
  name,
  label,
  departments,
  selecttedDepartment,
}) => {
  const { mode } = useContext(WindmillContext);
  const options =
    departments?.map((department) => ({
      value: department.id,
      label: department.title,
    })) ?? [];

  options.unshift({ value: "All", label: "ALL DEPARTMENTS" });

  const handleChange = (selectedOption) => {
    setSelecttedDepartment(selectedOption);
  };

  return (
    <>
      {options?.length > 0 && selecttedDepartment && (
        <Select
          key={selecttedDepartment.length}
          options={options}
          onChange={handleChange}
          isMulti
          name="department"
          defaultValue={selecttedDepartment}
          className="react-select-container text-sm"
          classNamePrefix="react-select"
          {...reactSelectCommonProps(mode === "dark")}
        />
      )}
    </>
  );
};

export default SelectDepartment;
